import projection from '../generated/pwn202f1.json';
import { AcceptanceManifest } from '../types';
export const pwn202f1AcceptanceManifest = projection as AcceptanceManifest;
